import $ from "jquery";

// Required if validation
$.validator.addMethod("requiredif", function (value, element, parameters) {
	// If this is an complex object we need to get the full name (example: User.Name.Firstname = User.Name )
	var modelPrefix = element.name.substr(0, element.name.lastIndexOf(".")),
		// Get all elements with this name
		otherElement = modelPrefix ? $("[name='" + modelPrefix + "." + parameters.othername + "']") : $("[name='" + parameters.othername + "']"),
		// Get the type of element, we need this to determine the value
		otherElementType = otherElement.attr("type"),
		// The actual value
		otherElementVal;

	// Get the value by type of element
	// If this is a checkbox just set value to true or false depending on if the element is checked
	// (This does not support multiple checkboxes)
	if (otherElementType === "checkbox") {
		otherElementVal = otherElement.is(":checked").toString();
	}
	// If this is a radio button, get the currently checked radio button
	else if (otherElementType === "radio") {
		otherElementVal = otherElement.filter(":checked").val();
	}
	// Else just get the value
	else {
		otherElementVal = otherElement.val();
	}

	// If the condition is true, reuse the existing required field validator functionality
	if (parameters.othervalue === otherElementVal) {
		return $.validator.methods.required.call(this, value, element, parameters);
	}

	// If the condition wasn't true, return true (this element was not requried)
	return true;
});
$.validator.unobtrusive.adapters.add("requiredif", ["othername", "othervalue"], function (options) {
	options.rules["requiredif"] = {
		othername: options.params["othername"],
		othervalue: options.params["othervalue"]
	};
	options.messages["requiredif"] = options.message;
});